import { render, staticRenderFns } from "./BackofficeConfirmarReservaSala.vue?vue&type=template&id=27cabe8b&scoped=true"
import script from "./BackofficeConfirmarReservaSala.vue?vue&type=script&lang=ts"
export * from "./BackofficeConfirmarReservaSala.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeConfirmarReservaSala.vue?vue&type=style&index=0&id=27cabe8b&prod&lang=scss&scoped=true"
import style1 from "./BackofficeConfirmarReservaSala.vue?vue&type=style&index=1&id=27cabe8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cabe8b",
  null
  
)

export default component.exports